import { useEffect, useState } from "react";
import { useAuthenticate } from "../context/AuthContext";
import axios from "axios";
import { api_url } from "../utils/data";
import { toast } from "react-toastify";

export const useDashboardData = () => {
  const { authToken } = useAuthenticate();
  const [subscriptionDetails, setSubscriptionDetails] = useState();
  const [loadingDashboardData, setLoadingDashboardData] = useState(true);
  const [dashboardData, setDashboardData] = useState({});
  const [notificationModal, setNotificationModal] = useState(false);
  const [expiringDrugsModal, setExpiringDrugsModal] = useState(false);
  const [takingAttendance, setTakingAttendance] = useState(false);

  const sendNotificationMail = async (alertType) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };

    if (subscriptionDetails?.package !== "Alpha") {
      try {
        await axios.get(`${api_url}/accounts/send_notification/${alertType}/`, config);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const getDashboardData = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };

    try {
      const response = await axios.get(`${api_url}/accounts/dashboard/`, config);
      
      if (response.data?.low_stock_drugs?.length > 0) {
        setNotificationModal(true);
        sendNotificationMail("low_stock");
      }
      
      if (response.data?.expiring_drugs?.length > 0) {
        setExpiringDrugsModal(true);
        sendNotificationMail("expiry");
      }
      
      setDashboardData(response.data);
      setLoadingDashboardData(false);
    } catch (error) {
      setLoadingDashboardData(false);
      handleApiError(error);
    }
  };

  const getSubscriptionDetails = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };

    try {
      const response = await axios.get(`${api_url}/subscription/pharmacy-subscription/`, config);
      
      if (response?.data?.success) {
        setSubscriptionDetails(response?.data?.subscription);
        getDashboardData();
      } else {
        window.location.href = "/no-subscription";
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleApiError = (error) => {
    if (error?.response?.status === 500) {
      return toast.error("Internal server error");
    }
    if (error?.response?.status === 400) {
      for (const property in error.response.data) {
        if (property !== "0") {
          toast.error(`${property}: ${error.response.data[property]}`);
        } else {
          toast.error(`${error.response.data[property]}`);
        }
      }
    } else {
      toast.error("Something went wrong");
    }
  };

  useEffect(() => {
    getSubscriptionDetails();
  }, []);

  return {
    subscriptionDetails,
    loadingDashboardData,
    dashboardData,
    notificationModal,
    setNotificationModal,
    expiringDrugsModal,
    setExpiringDrugsModal,
    takingAttendance,
    setTakingAttendance,
    getDashboardData
  };
};